import React from 'react';
import {
  Grid,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Link,
  Button,
  TableFooter,
  TablePagination,
  Typography,
  Badge,
} from '@material-ui/core';
import {
  AssessmentOutlined as AssessmentOutlinedIcon,
} from '@material-ui/icons';

import { Helmet } from 'react-helmet';

import Commify from 'comma-number';
import { isMobile } from 'react-device-detect';
import Moment from 'moment';
import QueryString from 'querystring';

import APIServer from '../../config/server.conf.json';

export default class StockConsensus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: {
        datelist: true,
        stocklist: true,
      }
    }
  }

  loadConsensusDateList = () => {
    return fetch(`${APIServer.baseUrl}/api/v1/stock/consensus/datelist`);
  }
  
  loadConsensusData = () => {
    if(this.state.selected_market === 'ALL') {
      return fetch(`${APIServer.baseUrl}/api/v1/stock/consensus/list/${this.state.selected_date}?${QueryString.stringify({
        market: this.state.selected_market,
        page: this.state.pagination.page,
        limit: this.state.pagination.limit,
        orderby: this.state.sort.orderby,
        order: this.state.sort.order
      })}`);
    }

    return fetch(`${APIServer.baseUrl}/api/v1/stock/consensus/list/${this.state.selected_date}?${QueryString.stringify({
      market: this.state.selected_market,
      page: this.state.pagination.page,
      limit: this.state.pagination.limit,
      orderby: this.state.sort.orderby,
      order: this.state.sort.order
    })}`);
  }

  loadRealtimeData = () => {
    console.log('realTime');
    let now = Moment();
    let start_time = Moment();
    let end_time = Moment();

    start_time.second(0);
    start_time.minute(0);
    start_time.hour(9);

    end_time.second(0);
    end_time.minute(30);
    end_time.hour(15);

    if(now.day() === 0 || now.day() === 6) {
      clearInterval(this.realtime_timer);
    } else if(now.diff(start_time, 'minutes') < 0 || now.diff(end_time, 'minutes') > 0) {
      clearInterval(this.realtime_timer);
    }

    console.log('get data');

    let list = this.state.stocklist.map((e) => { return e.symbol_code.substr(1) });

    fetch(`https://polling.finance.naver.com/api/realtime.nhn?query=SERVICE_RECENT_ITEM:${list.join(',')}`)
      .then((resp) => resp.json())
      .then((resp) => {
        let date = Moment(resp.result.time).format('YYYY-MM-DD HH:mm:ss');
        let org = this.state.stocklist;

        for(let i=0;i<org.length;i++) {
          org[i].latest_price_date = date;
          org[i].trade_price = resp.result.areas[0].datas[i].nv
        }

        this.setState({
          ...this.state,
          stocklist: org,
        });
      });
  }

  componentDidMount() {
    this.loadConsensusDateList()
      .then((resp) => resp.json())
      .then((resp) => {
        if(resp.status === 200) {
          this.setState({
            isLoading: {
              ...this.state.isLoading,
              datelist: false,
            },
            datelist: resp.data,
            selected_date: resp.data[0],
            selected_market: 'KOSPI',
            pagination: {
              page: 1,
              limit: 10
            },
            sort: {}
          }, () => {
            this.loadConsensusData()
              .then((resp2) => resp2.json())
              .then((resp2) => {
                if(resp2.status === 200) {
                  this.setState({
                    ...this.state,
                    isLoading: {
                      ...this.state.isLoading,
                      stocklist: false,
                    },
                    stocklist: resp2.data,
                  });
                }
              });
          });
        }
      });
    
    // this.setState({
    //   ...this.state,
    //   realtime_timer: setInterval(this.loadRealtimeData, 1000)
    // });
    // this.realtime_timer = setInterval(this.loadRealtimeData, 10000);
  }

  componentWillUnmount() {
    // clearInterval(this.realtime_timer);
  }

  handleDateOnChange = (e) => {
    this.setState({
      ...this.state,
      selected_date: e.target.value
    });
  }

  handleMarketOnChange = (e) => {
    this.setState({
      ...this.state,
      selected_market: e.target.value
    });
  }

  handleLoadOnClick = (e) => {
    this.setState({
      ...this.state,
      isLoading: {
        ...this.state.isLoading,
        stocklist: true,
      },
      pagination: {
        ...this.state.pagination,
        page: 1
      }
    }, () => {
      this.loadConsensusData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  }

  handleChangePage = (event, newPage) => {
    this.setState({
      ...this.state,
      pagination: {
        ...this.state.pagination,
        page: newPage + 1,
      }
    }, () => {
      this.loadConsensusData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({
      ...this.state,
      pagination: {
        page: 1,
        limit: parseInt(event.target.value, 10),
      }
    }, () => {
      this.loadConsensusData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  };

  handleChangeOrder = target => event => {
    let sort = {
      orderby: target,
      order: (this.state.sort.order === 'asc' ? 'desc':(this.state.sort.order === 'desc' ? false:'asc'))
    };
    let pagination = {
      page: 1,
      limit: this.state.pagination.limit
    };

    if(target !== this.state.sort.orderby) {
      sort.order = 'asc';
    }

    if(sort.order === false) {
      sort.orderby = undefined;
      sort.order = undefined;
    }

    this.setState({
      ...this.state,
      pagination: pagination,
      sort: sort
    }, () => {
      this.loadConsensusData()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                stocklist: false,
              },
              stocklist: resp.data
            });
          }
        });
    });
  }

  render() {
    return (
      <Grid container style={{ padding: 10, minHeight: 450 }} spacing={3}>
        <Helmet
          title="주식정보 - 컨센서스(전문가 의견)"
          meta={[
            { name: "description", content: "주식정보 - 컨센서스(전문가 의견)" },
            { name: "keywords", content: "toolbox, tbx, 툴박스, stock, 주식, 주식정보, ,컨센서스(전문가 의견)" },
            { property: "og:title", content: "주식정보 - 컨센서스(전문가 의견) - TBX" },
            { property: "og:description", content: "주식정보 - 컨센서스(전문가 의견) - TBX" },
            { property: "og:title", content: "주식정보 - 컨센서스(전문가 의견) - TBX" },
          ]}
        />
        {this.state.isLoading.datelist &&
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <CircularProgress color="secondary" size={50} />
        </Grid>}
        {!this.state.isLoading.datelist &&
        <Grid item xs={12}>
          <FormControl style={{ margin: 10, minWidth: 100 }}>
            <InputLabel shrink>
              Market
            </InputLabel>
            <Select
              value={this.state.selected_market}
              onChange={this.handleMarketOnChange}
            >
              <MenuItem key="ALL" value="ALL">
                All
              </MenuItem>
              <MenuItem key="KOSPI" value="KOSPI">
                KOSPI
              </MenuItem>
              <MenuItem key="KOSDAQ" value="KOSDAQ">
                KOSDAQ
              </MenuItem>
            </Select>
          </FormControl>
          <FormControl style={{ margin: 10, minWidth: 100 }}>
            <InputLabel shrink>
              Date
            </InputLabel>
            <Select
              value={this.state.selected_date}
              onChange={this.handleDateOnChange}
            >
              {
                this.state.datelist.map((e) => {
                  return (
                    <MenuItem key={e} value={e}>
                      {e}
                    </MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
          <FormControl style={{ margin: 10 }}>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              style={{ margin: 10 }}
              onClick={this.handleLoadOnClick}
            >
              조회
            </Button>
          </FormControl>
        </Grid>}
        
        {this.state.isLoading.stocklist &&
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <CircularProgress color="secondary" size={50} />
        </Grid>}
        {!this.state.isLoading.stocklist &&
        <Grid item xs={12}>
          <Typography variant="subtitle2" align="right">
            조회일: {this.state.stocklist.date}
          </Typography>
        </Grid>}
        {!this.state.isLoading.stocklist &&
        <Grid item xs={12}>
          <Paper variant="outlined">
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell key="head-num" align="center">
                      #
                    </TableCell>
                    <TableCell key="head-name" align="center"
                      sortDirection={this.state.orderby === 'name' ? this.state.order:false }
                    >
                      <TableSortLabel
                        active={this.state.orderby === 'name'}
                        direction={this.state.orderby === 'name' ? this.state.order:'asc'}
                        onClick={this.handleChangeOrder('name')}
                      >
                        종목명
                      </TableSortLabel>
                    </TableCell>
                    <TableCell key="head-market" align="center">
                      시장
                    </TableCell>
                    <TableCell key="head-marketRank" align="center"
                      sortDirection={this.state.orderby === 'market_rank' ? this.state.order:false }
                    >
                      <TableSortLabel
                        active={this.state.orderby === 'market_rank'}
                        direction={this.state.orderby === 'market_rank' ? this.state.order:'asc'}
                        onClick={this.handleChangeOrder('market_rank')}
                      >
                        시장 내 순위
                      </TableSortLabel>
                    </TableCell>
                    <TableCell key="head-regretBot" align="center"
                      sortDirection={this.state.orderby === 'regret' ? this.state.order:false }
                    >
                      <TableSortLabel
                        active={this.state.orderby === 'regret'}
                        direction={this.state.orderby === 'regret' ? this.state.order:'asc'}
                        onClick={this.handleChangeOrder('regret')}
                      >
                        후회봇
                      </TableSortLabel>
                    </TableCell>
                    <TableCell key="head-recentTradePrice" align="center"
                      sortDirection={this.state.orderby === 'latest_price' ? this.state.order:false }
                    >
                      <TableSortLabel
                        active={this.state.orderby === 'latest_price'}
                        direction={this.state.orderby === 'latest_price' ? this.state.order:'asc'}
                        onClick={this.handleChangeOrder('latest_price')}
                      >
                        최근가격
                      </TableSortLabel>
                    </TableCell>
                    <TableCell key="head-targetPrice" align="center"
                      sortDirection={this.state.orderby === 'target_price' ? this.state.order:false }
                    >
                      <TableSortLabel
                        active={this.state.orderby === 'target_price'}
                        direction={this.state.orderby === 'target_price' ? this.state.order:'asc'}
                        onClick={this.handleChangeOrder('target_price')}
                      >
                        목표 가격
                      </TableSortLabel>
                    </TableCell>
                    <TableCell key="head-targetPriceRate" align="center"
                      sortDirection={this.state.orderby === 'target_rate' ? this.state.order:false }
                    >
                      <TableSortLabel
                        active={this.state.orderby === 'target_rate'}
                        direction={this.state.orderby === 'target_rate' ? this.state.order:'asc'}
                        onClick={this.handleChangeOrder('target_rate')}
                      >
                        목표가 대비
                      </TableSortLabel>
                    </TableCell>
                    <TableCell key="head-consensus" align="center"
                      sortDirection={this.state.orderby === 'consensus' ? this.state.order:false }
                    >
                      <TableSortLabel
                        active={this.state.orderby === 'consensus'}
                        direction={this.state.orderby === 'consensus' ? this.state.order:'asc'}
                        onClick={this.handleChangeOrder('consensus')}
                      >
                        Consensus
                      </TableSortLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.stocklist.rows.length === 0 &&
                    <TableRow>
                      <TableCell
                        colSpan={10}
                        align="center"
                      >
                        No Data.
                      </TableCell>
                    </TableRow>
                  }
                  {this.state.stocklist.rows.map((e, i) => {
                    return (
                      <TableRow
                        key={i}
                        hover
                      >
                        <TableCell>
                          {((this.state.pagination.page - 1) * this.state.pagination.limit) + i + 1}
                          {e.date_list.length === 1 &&
                          <Badge color="secondary" badgeContent="NEW"></Badge>
                          }
                        </TableCell>
                        <TableCell>
                          {/* <Link href={isMobile ? `https://m.finance.daum.net/quotes/${e.symbol_code}/home`:`https://finance.daum.net/quotes/${e.symbol_code}`} target="new">
                            {e.name}
                          </Link> */}
                          <Link href={`https://finance.naver.com/item/main.nhn?code=${e.symbol_code.substr(1)}`} target="new">
                            {e.name}
                          </Link>
                          
                        </TableCell>
                        <TableCell align="center">
                          {e.market}
                        </TableCell>
                        {e.market_rank !== null &&
                          <TableCell align="right">
                            {Commify(e.market_rank)}위
                          </TableCell>
                        }
                        {e.market_rank === null && 
                          <TableCell align="right">
                            집계전
                          </TableCell>
                        }
                        {e.first_date_trade_price !== null &&
                        <TableCell align="center">
                          <div>
                            <span style={{
                              color: (e.latest_date_trade_price-e.first_date_trade_price) < 0 ? 'blue':((e.latest_date_trade_price-e.first_date_trade_price) === 0 ? 'black':'red')
                            }}>
                              {((e.latest_date_trade_price-e.first_date_trade_price) > 0 ? '+':'')}{Commify(e.latest_date_trade_price-e.first_date_trade_price)}
                            </span>원 
                            (<span style={{
                              color: (e.latest_date_trade_price-e.first_date_trade_price) < 0 ? 'blue':((e.latest_date_trade_price-e.first_date_trade_price) === 0 ? 'black':'red')
                            }}>
                              {((e.latest_date_trade_price-e.first_date_trade_price) > 0 ? '+':'')}{(((e.latest_date_trade_price-e.first_date_trade_price)/e.first_date_trade_price) * 100).toFixed(2)}%
                            </span>)
                          </div>
                          [{e.first_date} ~ {e.latest_date}]
                        </TableCell>}
                        {e.first_date_trade_price === null && 
                          <TableCell align="center">
                            -
                          </TableCell>
                        }
                        <TableCell align="center">
                          <div>
                            {Commify(e.latest_date_trade_price)}원 
                            (<span style={{
                              color: e.change === 'FALL' ? 'blue':(e.change_rate === 0 ? 'black':'red')
                            }}>
                              {e.change === 'FALL' ? '-':(e.change_rate === 0 ? '':'+')}{(e.change_rate * 100).toFixed(2)}%
                            </span>)
                          </div>
                          [{e.latest_date}]
                        </TableCell>
                        {e.target_price !== null &&
                          <TableCell align="right">
                            {Commify(e.target_price)}원
                          </TableCell>
                        }
                        {e.target_price === null &&
                          <TableCell align="right">
                            -
                          </TableCell>
                        }
                        {e.target_price !== null &&
                          <TableCell align="center">
                            <span style={{
                              fontWeight: 700,
                              color: (e.latest_date_trade_price - e.target_price) < 0 ? 'green':((e.latest_date_trade_price - e.target_price) === 0 ? 'black':'grey')
                            }}>
                              {(e.latest_date_trade_price - e.target_price) > 0 ? '+':''}{(((e.latest_date_trade_price - e.target_price) / e.target_price) * 100).toFixed(2)}%
                            </span>
                          </TableCell>
                        }
                        {e.target_price === null &&
                          <TableCell align="center">
                            -
                          </TableCell>
                        }
                        <TableCell align="center">
                          {e.lyr >= 0 && e.lyr <= 1.5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#5793eb' }}>
                            강력매도 ({e.lyr})
                          </Paper>}
                          {e.lyr > 1.5 && e.lyr <= 2.5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#5793eb' }}>
                            매도 ({e.lyr})
                          </Paper>}
                          {e.lyr > 2.5 && e.lyr <= 3.5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#68b728' }}>
                            중립 ({e.lyr})
                          </Paper>}
                          {e.lyr > 3.5 && e.lyr <= 4.5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#fe8917' }}>
                            매수 ({e.lyr})
                          </Paper>}
                          {e.lyr > 4.5 && e.lyr <= 5 &&
                          <Paper variant="outlined" style={{ textAlign: 'center', padding: 7, color: 'white', backgroundColor: '#d03b24' }}>
                            강력매수 ({e.lyr})
                          </Paper>}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[ 10, 25, 50, 100 ]}
                      rowsPerPage={this.state.pagination.limit}
                      count={this.state.stocklist.total}
                      page={this.state.pagination.page-1}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>}
      </Grid>
    );
  }
}